<template>
  <j-modal :title="title" :width="width" :visible="visible" switchFullscreen @ok="handleOk" :ok-disabled="disableSubmit"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }" @cancel="handleCancel" cancelText="关闭">
    <area-form ref="realForm" @ok="submitCallback" :from="from" :disabled="disableSubmit"></area-form>
  </j-modal>
</template>

<script>

import AreaForm from './AreaForm'

export default {
  name: 'AreaModal',
  components: {
    AreaForm
  },
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      disableSubmit: false,
      sysactivityid: '',
      sysvenueid: '',
      sysfloorid: '',
      parent: {},
    }
  },
  props: {
    //调用父页面
    from: {
      type: String,
      default: '',
      required: false
    }
  },
  methods: {
    refreshTree() {
      this.$emit('refreshTree');
    },
    add(record) {
      var that = this;
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.model.sysvenueid = this.sysvenueid;
        this.$refs.realForm.model.sysactivityid = this.sysactivityid;
        this.$refs.realForm.model.sysfloorid = this.sysfloorid;
        this.$refs.realForm.add(record);
      })
    },
    edit(record) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.edit(record);
      })
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      this.$refs.realForm.submitForm();
    },
    submitCallback() {
      this.$emit('ok');
      this.visible = false;
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>